import MigrationResultModal from './MigrationResultModal';

export default MigrationResultModal;
